import { render, staticRenderFns } from "./returnDetail.vue?vue&type=template&id=584d564b&scoped=true"
import script from "./returnDetail.vue?vue&type=script&lang=js"
export * from "./returnDetail.vue?vue&type=script&lang=js"
import style0 from "./returnDetail.vue?vue&type=style&index=0&id=584d564b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584d564b",
  null
  
)

export default component.exports